/*
 * @Author: Han
 * @Date: 2021-12-02 13:22:20
 * @LastEditors: Han
 * @LastEditTime: 2022-03-25 14:00:14
 * @FilePath: \yooacs\console\src\http\moudules\certificationAudit.js
 */
import axios from '../axios'

// 查询认证列表
export const getAuthList = (data) => {
  return axios({
    url: '/con/third/party/auth/getAuthList',
    method: 'GET',
    data
  })
}
// 新增教课程类型
export const addCourseType = (data) => {
  return axios({
    url: '/course/type/save',
    method: 'POST',
    data
  })
}
// 查询认证详情
export const getAuthDetail = (data) => {
  return axios({
    url: '/con/third/party/auth/getAuthDetail',
    method: 'GET',
    data
  })
}
//通过&驳回
export const updateAuthStatus = (data) => {
  return axios({
    url: '/con/third/party/auth/updateAuthStatus',
    method: 'GET',
    data
  })
}

// 课程审核列表
export const getClassCheckList = (data) => {
  return axios({
    url: '/course_auth/all_third_party_list',
    method: 'GET',
    data
  })
}

// 局端-认证审核-课程审核-待审核页面
export const getCheckClassList = (data) => {
  return axios({
    url: '/course_auth/one_third_party_list',
    method: 'GET',
    data
  })
}

// 局端-认证审核-课程审核-查看详情页面
export const getCheckClassInfos = (data) => {
  return axios({
    url: '/course_auth/course_detail',
    method: 'GET',
    data
  })
}

// 通过/驳回接口
export const authGo = (data) => {
  return axios({
    url: '/course_auth/auth',
    method: 'POST',
    data
  })
}


export const toSendAuth = (data) => {
  return axios({
    url: '/con/third/party/auth/submitAuthApply',
    method: 'GET',
    data
  })
}

export const newGetCourseType = (data) => {
  return axios({
    url: '/course/type/third_party_list',
    method: 'GET',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/certificationAudit.js